(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    (function () {
  function initializeBundleGalleries() {
    function isBundleGallery(element) {
      return element.matches('[data-product-photos]') && element.closest('.bcj-legacy-bundle-pdp');
    }
    function syncBundleThumbState(owner, index) {
      owner.childNavLinks.forEach(function (link, position) {
        var selected = position === Number(index);
        link.classList.toggle('is-active', selected);
        link.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    }
    var slideshow = window.theme && window.theme.Slideshow && window.theme.Slideshow.prototype;
    if (slideshow && !slideshow.bcjBundleNavigationInitialized) {
      var childNavGoTo = slideshow.childNavGoTo;
      var initChildNav = slideshow.initChildNav;
      slideshow.initChildNav = function () {
        var result = initChildNav.apply(this, arguments);
        if (isBundleGallery(this.el)) syncBundleThumbState(this, this.args.initialIndex);
        return result;
      };
      slideshow.childNavGoTo = function (index) {
        if (!isBundleGallery(this.el)) return childNavGoTo.apply(this, arguments);
        syncBundleThumbState(this, index);
        var link = this.childNavLinks[index];
        var scroller = this.args.childNavScroller;
        if (!link || !scroller) return;
        if (this.args.childVertical && scroller.scrollHeight > scroller.clientHeight) scroller.scrollTop = link.offsetTop - 100;
        else if (!this.args.childVertical && scroller.scrollWidth > scroller.clientWidth) scroller.scrollLeft = link.offsetLeft - 100;
      };
      slideshow.bcjBundleNavigationInitialized = true;
    }
    var flickity = window.Flickity && window.Flickity.prototype;
    if (flickity && !flickity.bcjBundleMotionInitialized) {
      var select = flickity.select;
      flickity.select = function (index, isWrap, isInstant) {
        if (isBundleGallery(this.element) && window.matchMedia('(prefers-reduced-motion: reduce)').matches) isInstant = true;
        return select.call(this, index, isWrap, isInstant);
      };
      flickity.bcjBundleMotionInitialized = true;
    }
  }
  function initializeBundlePrices() {
    initializeBundleGalleries();
    document.querySelectorAll('[data-bcj-legacy-product]').forEach(function (root) {
      if (root.bcjBundlePriceInitialized) return;
      var variants;
      try { variants = JSON.parse(root.dataset.bcjVariants); } catch (_) { return; }
      root.bcjBundlePriceInitialized = true;
      var pending = false;
      var frame = 0;
      var saleSignature = "";
      var controlsLocked = false;
      var controlSnapshots = [];
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
      var formatter;
      try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); } catch (_) {}
      function money(cents) { return formatter ? formatter.format(cents / 100) : (cents / 100).toFixed(2) + ' ' + currency; }
      function restoreSnapshotValues() {
        controlSnapshots.forEach(function (entry) {
          if ('value' in entry.control) entry.control.value = entry.value;
          if ('checked' in entry.control) entry.control.checked = entry.checked;
        });
      }
      function snapshotEditableControls() {
        return Array.prototype.slice.call(root.querySelectorAll('.js-qty__num, .js-qty__adjust, [data-variant-input], .variant-input input')).map(function (control) {
          return { control: control, disabled: control.disabled, value: control.value, checked: control.checked };
        });
      }
      function syncControlLock() {
        var requestPending = Boolean(root.querySelector('[data-add-to-cart].btn--loading, .btn-atc-sticky.btn--loading'));
        if (requestPending === controlsLocked) return;
        controlsLocked = requestPending;
        if (requestPending) {
          if (!controlSnapshots.length) controlSnapshots = snapshotEditableControls();
          controlSnapshots.forEach(function (entry) { entry.control.disabled = true; });
        } else {
          restoreSnapshotValues();
          controlSnapshots.forEach(function (entry) { entry.control.disabled = entry.disabled; });
          controlSnapshots = [];
        }
        root.querySelectorAll('[data-add-to-cart], .btn-atc-sticky').forEach(function (button) { button.setAttribute('aria-busy', requestPending ? 'true' : 'false'); });
      }
      function blockPendingInteraction(event) {
        syncControlLock();
        if (!controlsLocked) {
          // Capture editable values before the request owner changes button state,
          // without disabling fields before it builds the submitted FormData.
          if (event.type === 'submit') controlSnapshots = snapshotEditableControls();
          return;
        }
        if (event.type === 'submit' || event.target.closest('.product__quantity, .js-qty__wrapper, .variant-wrapper, .variant-input, [data-add-to-cart], .btn-atc-sticky')) {
          restoreSnapshotValues();
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
      function refresh() {
        pending = false;
        if (!root.isConnected) return;
        syncControlLock();
        var selected = root.querySelector('[name="id"]');
        var variant = variants.find(function (item) { return String(item.id) === String(selected && selected.value); }) || variants[0];
        if (!variant) return;
        var plan = root.querySelector('[name="selling_plan"]:checked') || root.querySelector('select[name="selling_plan"], input[type="hidden"][name="selling_plan"]');
        var planId = plan && !plan.disabled && plan.value !== '0' ? plan.value : '';
        var base = variant.price;
        if (planId) {
          var planPrices = root.querySelector('[data-bcj-plan-prices]');
          try {
            var allocations = JSON.parse(planPrices && planPrices.textContent || '{}');
            var planKey = String(variant.id) + ':' + planId;
            if (Object.prototype.hasOwnProperty.call(allocations, planKey)) base = allocations[planKey];
          } catch (_) {}
        }
        var price = base;
        var compare = Number(variant.compare_at_price) || 0;
        var signature = [variant.id, variant.price, compare, price, planId].join(':');
        var sale = root.querySelector('[data-bcj-sale-price]');
        if (sale && window.BCJSalePrice && signature !== saleSignature) {
          saleSignature = signature;
          window.BCJSalePrice.update(sale, { price: variant.price, compareAt: compare,
            currentPrice: planId ? price : undefined, handle: root.dataset.productHandle,
            variantId: variant.id, sellingPlanId: planId });
        }
        var saved = compare > price ? compare - price : 0;
        var percent = saved ? Math.round(saved / compare * 100) : 0;
        root.querySelectorAll('[data-bcj-bundle-savings]').forEach(function (node) {
          var content = saved ? node.dataset.saveTemplate.replace('[saved_amount]', money(saved) + ' (' + percent + '%)') : '';
          node.hidden = saved <= 0;
          if (node.textContent !== content) node.textContent = content;
        });
      }
      function schedule() {
        if (!pending) { pending = true; frame = requestAnimationFrame(refresh); }
      }
      var observer = new MutationObserver(function () { syncControlLock(); schedule(); });
      observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled', 'checked', 'class'] });
      ['click', 'input', 'change', 'submit'].forEach(function (type) { root.addEventListener(type, blockPendingInteraction, true); });
      root.addEventListener('change', schedule);
      root.addEventListener('variantPriceChange', schedule);
      window.addEventListener('bcj:promotion:change', schedule);
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('bcj:promotion:change', schedule);
        document.removeEventListener('shopify:section:unload', unload);
      });
      refresh();
    });
  }
  document.addEventListener('page:loaded', initializeBundlePrices);
  document.addEventListener('quickview:loaded', initializeBundlePrices);
  document.addEventListener('shopify:section:load', initializeBundlePrices);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeBundlePrices);
  else initializeBundlePrices();
})();
  } catch(e) { console.error(e); }
})();

})();
